import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  ContentComponent,
  HeaderComponent,
  LoaderComponent,
  ToasterComponent
} from '@maersk-global/angular-shared-library';
import { CompactSideMenuBarComponent } from '../../../../core/components/compact-sidemenubar/compact-sidemenubar.component';

@Component({
  selector: 'app-full-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    HeaderComponent,
    CompactSideMenuBarComponent,
    ContentComponent,
    ToasterComponent,
    LoaderComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './full-layout.component.html',
  styleUrl: './full-layout.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class FullLayoutComponent {
  
}
